document.addEventListener('DOMContentLoaded', function () {
  const summariesBlock = document.querySelector('.summaries-block');
  if (!summariesBlock) return;

  const sentinel = document.createElement('div');
  sentinel.classList.add('sticky-sentinel');
  summariesBlock.parentNode.insertBefore(sentinel, summariesBlock);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          summariesBlock.classList.add('is-sticky');
        } else {
          summariesBlock.classList.remove('is-sticky');
        }
      });
    },
    { rootMargin: '-100px 0px 0px 0px' }
  );

  observer.observe(sentinel);
});
